<template>
    <div class='watch-main'>
        <div class="header-box">
            <div class="header-item money" style="width: 5.06rem;">
                <img src="../../assets//wms/money.png" alt="">
                <div class="header-txt txt">
                    <span>总库存(吨)</span>
                    <span>{{ headData.inventoryWeight || 0 }}</span>
                </div>
                <div class="header-txt">
                    <span>货值(万元)</span>
                    <span>{{ headData.inventoryWeight || 0 }}</span>
                </div>
            </div>
            <div class="header-item hot" style="width: 6.25rem;">
                <img src="../../assets//wms/hot.png" alt="">
                <div class="header-txt txt">
                    <span>最低温度</span>
                    <span>{{ headData.minTemperature || 0 }}℃</span>
                </div>
                <div class="header-txt">
                    <span>最高温度</span>
                    <span>{{ headData.maxTemperature || 0 }}℃</span>
                </div>
                <div class="header-txt">
                    <span>平均仓内温度</span>
                    <span>{{ headData.aveTemperature || 0 }}℃</span>
                </div>
            </div>
            <div class="header-item water" style="width: 6.25rem;">
                <img src="../../assets//wms/water.png" alt="">
                <div class="header-txt txt">
                    <span>最低湿度</span>
                    <span>{{ headData.minHumidity || 0 }}%</span>
                </div>
                <div class="header-txt">
                    <span>最高湿度</span>
                    <span>{{ headData.maxHumidity || 0 }}%</span>
                </div>
                <div class="header-txt">
                    <span>平均仓内湿度</span>
                    <span>{{ headData.aveHumidity || 0 }}%</span>
                </div>
            </div>
            <div class="header-item warn" style="width: 4.25rem;">
                <img src="../../assets//wms/warn.png" alt="">
                <div class="header-txt txt">
                    <span>温度预警</span>
                    <span class="num">{{ headData.temperatureWarning || 0 }}</span>
                </div>
                <div class="header-txt">
                    <span>湿度预警</span>
                    <span class="num">{{ headData.humidityWarning || 0 }}</span>
                </div>
            </div>
        </div>
        <div class="footer-box">
            <div class="search">
                <el-select v-model="form.superviseId" placeholder="请输入或选择被监管方名称" filterable
                    style="margin-right: 0.2rem;font-size:0.13rem">
                    <el-option v-for="item in superviseList" :key="item.superviseId" :label="item.applyName" :value="item.superviseId">
                    </el-option>
                </el-select>
                <el-select v-model="form.granaryTenantId" @change="listChange" placeholder="选择企业"
                    style="margin-right: 0.2rem;font-size:0.13rem">
                    <el-option v-for="item in enterpriseList" :key="item.tenantId" :label="item.companyName"
                        :value="item.tenantId">
                    </el-option>
                </el-select>
                <el-select v-model="form.warehouseId" @change="listFoodChange" placeholder="所属仓库"
                    style="margin-right: 0.2rem;font-size:0.13rem">
                    <el-option v-for="item in houseList" :key="item.warehouseId" :label="item.warehouseName"
                        :value="item.warehouseId">
                    </el-option>
                </el-select>
                <el-select v-model="form.materialsTypeId" placeholder="粮食品种" style="margin-right: 0.2rem;font-size:0.13rem">
                    <el-option v-for="item in foodsList" :key="item.materialsTypeId" :label="item.materialsTypeName"
                        :value="item.materialsTypeId">
                    </el-option>
                </el-select>
                <div class="btn btn_1" @click="getList">查询</div>
                <div class="reset_btn btn_1" @click="reset">重置</div>
            </div>
            <div class="footer">
                <div class="footer-item" v-for="(item,i) in list" @click="getDetail(item)">
                    <div class="left">
                        <h3>{{item.warehouseName||'-' }}</h3>
                        <span class="text">{{ item.inventoryWeight||0 }}吨</span>
                        <span class="border">粮情检测</span>
                    </div>
                    <div class="right">
                        <h4>企业名称：{{item.companyName||'-' }}</h4>
                        <h5>粮食品种：{{ item.materialsTypeName||'-' }}</h5>
                        <div style="display: flex;">
                            <div class="right-item">
                                <span>仓内温度：{{item.currentTemperature||0}}℃</span>
                                <span style="margin-top: .18rem;">平均温度：{{item.aveTemperature||0}}℃</span>
                            </div>
                            <div class="right-item" style="margin-left: .38rem;">
                                <span>最高温度：{{item.maxTemperature||0}}℃</span>
                                <span style="margin-top: .18rem;">最低温度：{{item.minTemperature||0}}℃</span>
                            </div>
                        </div>
                        <h5>最近更新时间：{{ item.updateTime||'-' }}</h5>
                    </div>
                </div>
            </div>
        </div>
        <detailDialog :dialogData='dialogData'  :dialogVisible.sync='dialogVisible'></detailDialog>
    </div>
</template>

<script>
import detailDialog from './components/detailDialog';
import {
		chartData
	} from './components/data.js';
import {
    getData, getManyList,getSuperviseList
} from "@/api/wms/detection.js";
export default {
    name: 'detection',
    components: { detailDialog },
    data() {
        return {
            dialogVisible: false,
            superviseList: [],
            enterpriseList: [],
            houseList: [],
            foodsList: [],
			warehouseData:null,//
            form: {
                "superviseId": null, //监管单ID
                "granaryTenantId": null, //粮仓企业ID
                "warehouseId": null, //仓库ID
                "materialsTypeId": null //物料类型ID   
            },
            params: {
                "superviseId": null, //监管单ID
                "granaryTenantId": null, //粮仓企业ID
                "warehouseId": null, //仓库ID
                "materialsTypeId": null //物料类型ID
            },
            headData: {},
            list:[],
			chartData:[],
			dialogData:{}
        }
    },
    created() {
		
        this.getData()
        // 获取企业+仓库+物料
        this.getManyList()
        // 获取被监管方名称
        this.getSuperviseList()
        this.getList()
    },
    methods: {
		getDetail(item){
			console.log(item)
			this.dialogData=JSON.parse(JSON.stringify(item))
			this.warehouseData=item
			this.chartData=JSON.parse(JSON.stringify(item.solidList))
			// console.dir(JSON.stringify(this.chartData))
			
			console.log(item.solidList)
			console.log(this.chartData)
			this.dialogVisible = true
		},
        listChange(val) {
            this.house = '',
                this.food = '',
                this.houseList = [],
                this.foodsList = [],
                this.enterpriseList.forEach((item, i) => {
                    if (item.tenantId == val) {
                        this.houseList = item.monitorWarehouseList
                    }
                })
        },
        listFoodChange(val) {
            this.food = '',
                this.foodsList = [],
                this.houseList.forEach((item, i) => {
                    if (item.warehouseId == val) {
                        this.foodsList = item.warehouseMaterialsList
                    }
                })
        },
        async getData() {
            const { data } = await getData(this.params)
            this.headData = data.result
        },
        // 获取底部仓库列表
        async getList() {
            const { data } = await getData(this.form)
            this.list = data.result.sensorWarehouseList
        },
        async getManyList() {
            const { data } = await getManyList({ "superviseId": null })
            if (data.result && data.result.length > 0) {
                this.enterpriseList = data.result
            }

        },
        async getSuperviseList(){
            const { data } = await getSuperviseList({})
            if (data.result && data.result.length > 0) {
                this.superviseList = data.result
            }
        },
        goDialog() {

        },
        reset() {
            this.form = {
                "superviseId": null, //监管单ID
                "granaryTenantId": null, //粮仓企业ID
                "warehouseId": null, //仓库ID
                "materialsTypeId": null //物料类型ID   
            },
                this.houseList = [],
                this.foodsList = [],
                this.getList()

        },


    },




};
</script>



<style lang="scss" scoped>
.watch-main {
    // display: flex;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.header-box {
    position: relative;
    padding: .3rem .34rem .31rem .36rem;
    // margin: .3rem .34rem .31rem .36rem;
    display: flex;
    height: 1.25rem;

    .header-item {
        display: flex;
        align-items: center;
        height: 1.25rem;
        padding: .29rem .25rem;
        background: rgba(255, 255, 255, 0.08);
        border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
        opacity: 1;

        img {
            width: .68rem;
            height: .68rem;
        }

        .header-txt {
            display: flex;
            flex-direction: column;
            margin-left: .75rem;

            span:nth-child(1) {
                font-size: 0.2rem;
                font-family: Source Han Sans-Regular, Source Han Sans;
                font-weight: 400;
                color: #FFFFFF;
            }

            span:nth-child(2) {
                font-size: 0.33rem;
                font-family: DIN-Bold, DIN;
                font-weight: 700;
                color: #19ECFF;
                padding-top: .2rem;
            }

            .num {
                color: #FFBB00 !important;
            }
        }

        .txt {
            margin-left: .28rem;
        }
    }

    .header-item:nth-child(n+2) {
        margin-left: .33rem;
    }

    &::after {
        content: '';
        position: absolute;
        bottom: -0.61rem;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: rgba(255, 255, 255, 0.18);
    }
}

.footer-box {
    padding-top: .88rem;

    .search {
        height: .38rem;
        display: flex;
        align-items: center;
        position: relative;
        margin-left: .38rem;

        .btn_1 {
            width: 1rem;
            height: 0.4rem;
            font-size: 0.18rem;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            text-align: center;
            line-height: .38rem;
            cursor: pointer;
        }

        .btn {
            background: #00E0DB;
            border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
            opacity: 1;
            color: #032929;
            margin-left: 0.76rem;
        }

        .reset_btn {
            // background: #013D4E;
            border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
            opacity: 1;
            color: #00E0DB;
            margin-left: 0.11rem;
            border: 0.01rem solid #19ECFF;
        }
    }

    .footer {
        display: flex;
        flex-wrap: wrap;
        height: 9rem;
        overflow: auto;

        .footer-item {
            display: flex;
            width: 5.38rem;
            height: 2.25rem;
            background: rgba(255, 255, 255, 0.08);
            border-radius: 0.13rem 0.13rem 0.13rem 0.13rem;
            opacity: 1;
            border: 0.01rem solid rgba(255, 255, 255, 0.14);
            margin: .38rem 0 0 .38rem;
            cursor: pointer;

            .left {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                width: 1.63rem;
                height: 2.25rem;
                background: rgba(25, 236, 255, 0.08);
                border-radius: 0.13rem 0rem 0rem 0.13rem;
                opacity: 1;
                color: #19ECFF;
                font-family: Source Han Sans-Medium, Source Han Sans;


                h3 {
                    font-size: 0.25rem;
                    font-weight: 500;
                }

                .text {
                    padding: .25rem 0;
                }

                .border {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 0.95rem;
                    height: 0.33rem;
                    border-radius: 0.06rem 0.06rem 0.06rem 0.06rem;
                    border: 0.01rem solid #19ECFF;

                }
            }

            .right {
                font-size: 0.15rem;
                font-family: Source Han Sans-Normal, Source Han Sans;
                font-weight: 350;
                color: #D0D0D0;
                padding: .2rem;


                h4 {
                    font-size: 0.15rem;
                    font-family: Source Han Sans-Medium, Source Han Sans;
                    font-weight: 500;
                    color: #FFFFFF;
                }

                h5 {
                    font-size: 0.15rem;
                    font-family: Source Han Sans-Normal, Source Han Sans;
                    font-weight: 350;
                    color: #D0D0D0;
                }

                h4,
                h5,
                .right-item {
                    margin-top: .18rem;
                }

                .right-item {
                    display: flex;
                    flex-direction: column;
                }
            }
        }
    }
}

::v-deep .el-input__inner {
    width: 3.25rem;
    height: 0.4rem;
    background: rgba(255, 255, 255, 0.08);
    border: none;
    border-radius: 0.03rem;
    color: #FFFFFF !important;
    font-size: .18rem !important;
    border: 0.01rem solid rgba(255, 255, 255, 0.2);
}

// ::v-deep .search_input.el-input .el-input__inner {
//     width: 2.25rem !important;
// }

::v-deep .el-input__icon {
    color: #00E0DB;
}


::v-deep .el-select .el-input .el-select__caret {
    color: #00E0DB !important;
    line-height: .33rem;

}

.search_input>.el-input__inner {
    padding: 0 0 0 .4rem;
}</style>